---
title: Overdrive
description: "An overdrive device: a band-pass before a soft clip, a drive, a tone and a mix, a panel that draws the band that reaches the clip, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-overdrive" />

A pedal-style distortion. A band-pass filter picks what is pushed into the soft clip, so the lows do not turn to mud. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="overdrive" kind="device" />

## Controls

<DeviceControls device="overdrive">
<Control id="bandHz">The centre of the band that reaches the clip. Drag the handle on the plot across to set it.</Control>
<Control id="width">The width of that band. A high value is narrow.</Control>
<Control id="driveDb">How hard the band is pushed into the clip.</Control>
<Control id="toneHz">Closes the highs after the clip.</Control>
<Control id="mix">The balance of the distorted signal and the clean one.</Control>
</DeviceControls>

## Panel

The panel draws the band-pass that picks what reaches the clip, with a handle on its centre. `overdriveBand(state)` is the curve it draws. Pass a spectrum to the panel to see what comes out behind the curve.

<DeviceUsage name="overdrive" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

Only what the band-pass lets through goes into the clip, and the clean sound goes round it in the dry path. The drive is a gain before one fixed soft-clip table, and the shaper oversamples 4x to keep the clip from aliasing. That oversampling is the [latency](/docs/devices#latency) of the device.
